/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_tm_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uracil is read as thymine, but the nearest-neighbor parameters are for DNA. Ambiguous IUPAC codes are not supported — the sequence must be A, C, G and T (or U).`)
};

const es_tm_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El uracilo se lee como timina, pero los parámetros de vecino más cercano son para ADN. Los códigos IUPAC ambiguos no son compatibles — la secuencia debe ser A, C, G y T (o U).`)
};

const de_tm_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uracil wird als Thymin gelesen, aber die Nearest-Neighbor-Parameter gelten für DNA. Mehrdeutige IUPAC-Codes werden nicht unterstützt — die Sequenz muss aus A, C, G und T (oder U) bestehen.`)
};

const nl_tm_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uracil wordt gelezen als thymine, maar de nearest-neighbor-parameters zijn voor DNA. Ambigue IUPAC-codes worden niet ondersteund — de sequentie moet A, C, G en T (of U) zijn.`)
};

const fr_tm_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'uracile est lu comme la thymine, mais les paramètres des plus proches voisins sont pour l'ADN. Les codes IUPAC ambigus ne sont pas pris en charge — la séquence doit être A, C, G et T (ou U).`)
};

const it_tm_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'uracile viene letto come timina, ma i parametri dei vicini più prossimi sono per il DNA. I codici IUPAC ambigui non sono supportati — la sequenza deve essere A, C, G e T (o U).`)
};

const pt_br2_tm_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A uracila é lida como timina, mas os parâmetros do vizinho mais próximo são para DNA. Códigos IUPAC ambíguos não são suportados — a sequência deve ser A, C, G e T (ou U).`)
};

const pt_tm_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O uracilo é lido como timina, mas os parâmetros do vizinho mais próximo são para ADN. Os códigos IUPAC ambíguos não são suportados — a sequência deve ser A, C, G e T (ou U).`)
};

const ja_tm_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ウラシルはチミンとして読み取られますが、最近接塩基対法のパラメータはDNA用です。あいまいなIUPACコードには対応していません — 配列はA、C、G、T（またはU）である必要があります。`)
};

const zh_tm_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尿嘧啶按胸腺嘧啶处理，但最近邻参数是针对 DNA 的。不支持 IUPAC 简并码——序列必须为 A、C、G 和 T（或 U）。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tm_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tm_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("tm_faq_a4", locale)
	if (locale === "en") return en_tm_faq_a4(inputs)
	if (locale === "es") return es_tm_faq_a4(inputs)
	if (locale === "de") return de_tm_faq_a4(inputs)
	if (locale === "nl") return nl_tm_faq_a4(inputs)
	if (locale === "fr") return fr_tm_faq_a4(inputs)
	if (locale === "it") return it_tm_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_tm_faq_a4(inputs)
	if (locale === "pt") return pt_tm_faq_a4(inputs)
	if (locale === "ja") return ja_tm_faq_a4(inputs)
	return zh_tm_faq_a4(inputs)
};